import React from 'react';
import { ContentItemWrapper } from '../../ContentItem.styles';
import ContentItemFigure from '../ContentItemFigure/ContentItemFigure';

const Placeholder = ({ content }) => (
    <ContentItemWrapper>
        <ContentItemFigure content={content} showPlaceholder />
    </ContentItemWrapper>
);

export default Placeholder;
